import React, { useState, useEffect } from "react";
import "../assets/css/login.css";
import { useGoogleLogin } from "@react-oauth/google";
import { Box, Typography, useTheme } from "@mui/material";
import Grid from "@mui/material/Grid";
import { useNavigate, useLocation } from "react-router";
import { useGoogleAuth } from "../contexts/GoogleAuthContext";

import Footer from "../layouts/Footer";
import { isAccessedFromQBurstApps } from "../utils/helpers";
import Loading from "../components/Loading";
import { ConfirmDialog } from "../components/ConfirmDialog";

const GoogleLoginPage: React.FC = () => {
  const [errorMessage, setErrorMessage] = useState("");
  const {
    userLogin,
    accessToken,
    isQBurstAppsLoggingIn,
    unregisteredUserDialogOpen,
    unregisteredUserRedirectUrl,
    handleUnregisteredUserDialogClose,
  } = useGoogleAuth();

  const theme = useTheme();
  const navigate = useNavigate();
  const location = useLocation();
  const from = (location.state as { from?: Location })?.from;

  useEffect(() => {
    if (accessToken) {
      navigate(
        from
          ? `${(from as any).pathname}${(from as any).search ?? ""}${(from as any).hash ?? ""}`
          : "/",
        { replace: true },
      );
    }
  }, [accessToken, navigate, from]);

  const login = useGoogleLogin({
    onSuccess: async (tokenResponse) => {
      const { isLoggedIn, errorMessage } = await userLogin(tokenResponse);
      if (errorMessage) setErrorMessage(errorMessage);
      if (isLoggedIn) {
        const destination = from
          ? `${(from as any).pathname}${(from as any).search ?? ""}${(from as any).hash ?? ""}`
          : "/";
        navigate(destination, { replace: true });
      } else {
        navigate("/login");
      }
    },
    onError: (error) => {
      console.error("Google Login Error", error);
    },
  });

  return (
    <Box sx={{ display: "flex", flexDirection: "column", height: "100vh" }}>
      <Loading open={isQBurstAppsLoggingIn} type="qb-loader" />
      <Grid
        container
        sx={{
          display: "flex",
          flexDirection: "row",
          flexWrap: "nowrap",
          flexGrow: 1,
          height: "calc(100vh - 60px)",
        }}
      >
        <Grid
          size={{ xs: 6, md: 6 }}
          sx={{
            backgroundColor: "white",
            display: { xs: "none", sm: "flex" },
            alignItems: "center",
            justifyContent: "center",
            borderRadius: "16px",
            margin: "24px",
          }}
        >
          <img
            src="images/left-side-image.svg"
            alt="login page"
            style={{ maxHeight: "100%", maxWidth: "100%" }}
          ></img>
        </Grid>
        <Grid
            size={{ xs: 12, sm: 6 }}
            sx={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
              px: { xs: 0, sm: "6rem" },
            }}
          >
          <Typography
            sx={{
              borderRadius: "4px",
              color: "#343A40",
              fontSize: { md: "1.75rem", lg: "1.75rem" },
              fontWeight: 300,
              px: 1,
              textAlign: "center",
              mb: 2,
            }}
          >
            Welcome to
          </Typography>
          <Grid container justifyContent={"center"} pb={5}>
              <img
                src="images/databoard-icon.svg"
                alt="icon"
                style={{ paddingRight: "16px" }}
              ></img>
              <Typography
                variant="h6"
                noWrap
                component="div"
                sx={{
                  display: {
                    sm: "block",
                    fontWeight: "700",
                    fontSize: "36px",
                    textAlign: "center",
                    lineHeight: "1.8rem",
                  },
                }}
              >
                QB <span style={{ color: theme.palette.primary.main }}>D</span>ataboard
              </Typography>
            </Grid>
            {!isAccessedFromQBurstApps() && <button onClick={() => login()} className="google-login">
              <img
                src="images/btn_google_signin_light_normal_web@2x 1.svg"
                alt="google login"
                className="icon"
              ></img>
            </button>}
            {errorMessage && <div>{errorMessage}</div>}
        </Grid>
      </Grid>
      <Footer />
      <ConfirmDialog
        open={unregisteredUserDialogOpen}
        redirectUrl={unregisteredUserRedirectUrl}
        onClose={handleUnregisteredUserDialogClose}
      />
    </Box>
  );
};

export default GoogleLoginPage;
